import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./core/guards/auth/auth.guard";

const routes: Routes = [
  {
    path: "login",
    loadChildren: () =>
      import("@flexyear-modules/auth/login/login.module").then(
        (m) => m.LoginModule,
      ),
  },
  {
    path: "company-registration",
    loadChildren: () =>
      import("@flexyear-modules/companyregister/companyregister.module").then(
        (m) => m.CompanyregisterModule,
      ),
  },
  {
    path: "forgot-password",
    loadChildren: () =>
      import("@flexyear-modules/forgotpassword/forgotpassword.module").then(
        (m) => m.ForgotpasswordModule,
      ),
  },
  {
    path: "guide",
    loadChildren: () =>
      import("@flexyear-modules/guide/guide.module").then((m) => m.GuideModule),
  },
  {
    path: "pin-login",
    loadChildren: () =>
      import("@flexyear-modules/auth/login/login.module").then(
        (m) => m.LoginModule,
      ),
  },
  {
    path: "loginwithkey",
    loadChildren: () =>
      import("@flexyear-modules/auth/login/login.module").then(
        (m) => m.LoginModule,
      ),
  },
  {
    path: "",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./core/shell/shell.module").then((m) => m.ShellModule),
  },
  { path: "**", redirectTo: "login", pathMatch: "full" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "top",
      anchorScrolling: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
